import React from 'react'
import injectSheet from 'react-jss'

const ListTile = (props) => {
  const {
    children,
    classes,
    index,
    length,
    theme,
  } = props

  return (
    <li
      className={`${classes.listItem} ${(length < 3) ? classes.wide : ''} appear-element`}
      style={{ transitionDelay: `${(index * theme.speed.superFast) + theme.speed.fast}ms` }}
    >
      {children}
    </li>
  )
}


const styles = theme => ({
  listItem: {
    width: `calc(${100}% - ${theme.sizes.gutter}px)`,
    margin: `${theme.sizes.gutter / 2}px`,
    height: `${100 / theme.ratio.tile}vw`,
    [theme.media.medium]: {
      height: `${(100 / 2) / theme.ratio.tile}vw`,
      maxHeight: `${(theme.sizes.container / 2) / theme.ratio.tile}px`,
      width: `calc(${100 / 2}% - ${theme.sizes.gutter}px)`,
    },
    [theme.media.large]: {
      height: `${(100 / 3) / theme.ratio.tile}vw`,
      maxHeight: `${(theme.sizes.container / 3) / theme.ratio.tile}px`,
      width: `calc(${100 / 3}% - ${theme.sizes.gutter}px)`,
    },
    '& > div': {
      boxShadow: `${theme.shadow.initial}`,
      transform: 'translateY(0) scale(1)',
      transition: [
        {
          property: 'box-shadow',
          duration: theme.speed.veryFast,
        },
        {
          property: 'transform',
          duration: theme.speed.veryFast,
        },
      ],
      '&:hover': {
        boxShadow: `${theme.shadow.hover}`,
        transform: 'translateY(0) scale(1.02)',
      },
    },
  },
  wide: {
    width: `calc(${100}% - ${theme.sizes.gutter}px)`,
    [theme.media.medium]: {
      height: `${(100 / 2) / theme.ratio.tile}vw`,
      maxHeight: `${(theme.sizes.container / 2) / theme.ratio.tile}px`,
      width: `calc(${100 / 2}% - ${theme.sizes.gutter}px)`,
    },
  },
})

export default injectSheet(styles)(ListTile)



// WEBPACK FOOTER //
// ./src/modules/core/components/listTileItem.jsx